<template>
  <!-- Mirrors ProductGrid's layout so pages hold their shape before products exist. -->
  <div class="placeholder-grid">
    <div v-for="n in count" :key="n" class="placeholder-card" aria-hidden="true">
      <div class="placeholder-card__media">
        <PlaceholderArt :tone="n" />
      </div>
      <p class="placeholder-card__title">Coming soon</p>
      <p class="placeholder-card__price">—</p>
    </div>
  </div>
</template>

<script>
import PlaceholderArt from './PlaceholderArt.vue'

export default {
  name: 'PlaceholderGrid',

  components: { PlaceholderArt },

  props: {
    count: { type: Number, default: 8 },
  },
}
</script>

<style scoped>
.placeholder-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.4rem;
  row-gap: 4rem;
}

.placeholder-card__media { aspect-ratio: 4 / 5; }

.placeholder-card__title {
  font-family: var(--font-display);
  font-size: 2rem;
  margin: 1.4rem 0 0.4rem;
  color: var(--stone);
}

.placeholder-card__price {
  font-size: 1.4rem;
  color: var(--warm-grey);
}

@media (max-width: 1200px) {
  .placeholder-grid { grid-template-columns: repeat(3, 1fr); }
}

@media (max-width: 960px) {
  .placeholder-grid { grid-template-columns: repeat(2, 1fr); gap: 1.2rem; row-gap: 3.2rem; }
}
</style>
